/* @flow */

import { trackStructuredEvent } from "shared/src/utils/TrackingUtil";

const nameString = (eventName: string) => "user." + eventName;

export function trackCustomerChangeStore(storeName: string | undefined | null, storeId: string | undefined | null) {
    trackStructuredEvent(nameString("changeStore"), {
        tags: {
            storeName,
            storeId
        }
    });
}
